/**
 * @file 导出项目积分明细 hook
 */
import {useMutation} from '@tanstack/react-query';
import message from '@/components/common/Message';
import type {ProjectTransactionsExportParams} from '@/services/points/interface';
import {exportProjectTransactions} from '@/services/points';
import {useFileDownload} from '@/hooks/useFileDownload';

/**
 * 导出项目积分明细：请求服务端生成 Excel，拿到下载 URL 后触发浏览器下载。
 * 通过 isPending 暴露 loading 态供按钮使用。
 */
export const useExportProjectTransactions = () => {
    const {download} = useFileDownload();
    return useMutation({
        mutationFn: (params: ProjectTransactionsExportParams) => exportProjectTransactions(params),
        onSuccess: (data) => {
            if (!data.url) {
                message.error('导出失败，请稍后重试');
                return;
            }
            download({url: data.url, fileName: data.fileName});
        },
        onError: () => {
            message.error('导出失败，请稍后重试');
        },
    });
};
